import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '../../../theme/libs/media';
import { FlexRowCenterVertical } from '@bart.sk-eshop/eshop-defaults';
import { theme } from '../../../theme/theme';
import * as cookie from 'react-cookies';

interface TopPromoBarProps {
  text: string;
  link: string;
}

const PROMO_BAR_DISMISSED_COOKIE = 'promo_bar_dismissed';

const TopPromoBar: React.FC<TopPromoBarProps> = ({ text, link }) => {
  const [isDismissed, setIsDismissed] = React.useState(false);

  React.useEffect(() => {
    const dismissed = cookie.load(PROMO_BAR_DISMISSED_COOKIE);
    if (dismissed === text) {
      setIsDismissed(true);
    }
  }, []);

  const handleClose = () => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    cookie.save(PROMO_BAR_DISMISSED_COOKIE, text, {
      path: '/',
      expires: expirationDate,
    });
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <BarContainer href={link}>
      <BarContent>
        <BarText dangerouslySetInnerHTML={{ __html: text }} />
        <CloseButton
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
          }}
          aria-label="Close"
        >
          ×
        </CloseButton>
      </BarContent>
    </BarContainer>
  );
};

export default TopPromoBar;

// Styled Components

const BarContainer = styled.a`
  display: block;
  width: 100%;
  background: ${theme.color.black};
  color: ${theme.color.white};
  text-decoration: none;
  padding: ${rem(5)} ${rem(15)};
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  position: sticky;
  top: 0;
  z-index: 1001;

  &:hover {
    background: ${theme.color.gray48};
    text-decoration: none;
    color: ${theme.color.white};
  }

  ${media(0, 'md')} {
    padding: ${rem(4)} ${rem(12)};
  }
`;

const BarContent = styled(FlexRowCenterVertical)`
  max-width: 1400px;
  margin: 0 auto;
  justify-content: center;
  position: relative;
  gap: ${rem(10)};

  ${media(0, 'md')} {
    gap: ${rem(8)};
  }
`;

const BarText = styled.div`
  font-size: ${rem(14)};
  font-weight: 700;
  line-height: 1.4;
  color: ${theme.color.white};
  text-align: center;
  flex: 1;

  ${media(0, 'md')} {
    font-size: ${rem(12)};
  }

  span {
    font-size: ${rem(14)};
    font-weight: 700;
    line-height: 1.4;
    color: ${theme.color.white};
    text-align: center;
    flex: 1;

    ${media(0, 'md')} {
      font-size: ${rem(12)};
    }
  }

  p {
    margin: 0;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${theme.color.white};
  font-size: ${rem(24)};
  cursor: pointer;
  padding: 0;
  width: ${rem(32)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }

  ${media(0, 'md')} {
    font-size: ${rem(20)};
    width: ${rem(28)};
    height: ${rem(28)};
  }
`;
